export const body = document.querySelector('.body');
export const header = document.querySelector('.header');